// @ts-nocheck
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

/* Store Custom Code - Start */
// Hide non-searchable products from every product-collection fetch that flows through the
// `loadProducts` chain (product list, carousels, purchased products, compare, quick-order, etc.).
// Reporting bypasses this chain (direct service calls), so it stays exempt. Setting `searchable`
// on `apiParameter` (used by RequestDataFromApi) — not `parameter` — keeps the data-view cache
// keys unchanged, so no redundant fetches are introduced.
addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.searchable = true;
});
/* Store Custom Code - End */
